import { render, staticRenderFns } from "./SpamHistory.vue?vue&type=template&id=679510fc&scoped=true&"
import script from "./SpamHistory.vue?vue&type=script&lang=js&"
export * from "./SpamHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679510fc",
  null
  
)

export default component.exports